import { type AxiosRequestConfig } from 'axios'

const getEventsPermission = (): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: `/events/permission`
  }
}

export { getEventsPermission }
